import { Outlet } from "react-router-dom";

const MedicationCategory = () => {

  return <Outlet />
}

export default MedicationCategory;